import { gql } from '@apollo/client';

export const CREATE_CLARIFICATION_FIELD = gql`
  mutation CreateClarificationField($params: CreateClarificationFieldInput!) {
    createClarificationField(params: $params) {
      success
      message
      errors
      data {
        id
        clarificationSchemaId
        field
        label
        priority
        examples
        defaultBehavior
        applicableTo
        dynamicOptions
        stage
        valueMap
        includeInQuery
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_CLARIFICATION_FIELD = gql`
  mutation UpdateClarificationField($params: UpdateClarificationFieldInput!) {
    updateClarificationField(params: $params) {
      success
      message
      errors
      data {
        id
        clarificationSchemaId
        field
        label
        priority
        examples
        defaultBehavior
        applicableTo
        dynamicOptions
        stage
        valueMap
        includeInQuery
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_CLARIFICATION_FIELD = gql`
  mutation DeleteClarificationField($params: DeleteClarificationFieldInput!) {
    deleteClarificationField(params: $params) {
      success
      message
      errors
    }
  }
`;
